<mat-card>
    <mat-card-content i18n="@@emailVerifiedSuccessfullyMessage">
        Your email has been verified successfully
    </mat-card-content>
</mat-card>
